<template>
    <div v-if="statusId" class="sportFootballMatchStatusPeriod">
      <div class="settings" />
      <div class="start">
        <status-period-button :name="statusName" :active="statusId === match.statusId" @update="updateStatus"/>
      </div>
      <div class="startDate">
        <status-period-date title="Début" :date="date" @update="updateDate"/>
      </div>
      <div class="end">
        <status-period-button :name="statusNextName" :active="statusNextId === match.statusId" @update="updateStatusNext"/>
      </div>
      <div class="endOther" v-if="end">
        <status-period-button name="Fin" :active="[1,2,3].indexOf(match.statusId) > -1" @update="updateStatusEnd" />
      </div>
      <div class="endDate">
        <status-period-date title="Fin" :date="dateNext" @update="updateDateNext" />
      </div>
      <div class="stopwatch">
        <status-period-stopwatch :start="dateOffset" :end="dateEnd" :statusId="statusId" @update="updateDate"/>
      </div>
      <div class="offset">
        <status-period-offset :start="date" :end="dateOffset" />
      </div>
      <div class="score">
        <status-period-score :home="scoreHome" :away="scoreAway"/>
      </div>
    </div>
</template>

<script>
import StatusPeriodButton from './StatusPeriodButton'
import StatusPeriodDate from './StatusPeriodDate'
import StatusPeriodScore from './StatusPeriodScore'
import StatusPeriodStopwatch from './StatusPeriodStopwatch'
import StatusPeriodOffset from './StatusPeriodOffset'
import { status } from '@/store/model/sport/football/Status'

export default {
  name: 'SportFootballMatchStatusPeriod',
  components: { StatusPeriodButton, StatusPeriodDate, StatusPeriodOffset, StatusPeriodScore, StatusPeriodStopwatch },
  props: {
    match: Object,
    statusId: Number
  },
  data () {
    return {
    }
  },
  computed: {
    statusName () { return status.shortnameButton(this.statusId) },
    dateName () { return status.date(this.statusId) },
    date () { return this.match[this.dateName] },
    dateOffset () { return this.match[this.dateName + 'Offset'] },

    statusNextId () { return status.next(this.statusId) },
    statusNextName () { return status.shortnameButton(this.statusNextId) },
    dateNextName () { return status.date(this.statusNextId) },
    dateNext () { return this.match[this.dateNextName] },

    end () { return status.end(this.statusId) },

    scoreName () { return status.score(this.statusId) },
    scoreHome () { return this.match['scoreHome' + this.scoreName] },
    scoreAway () { return this.match['scoreAway' + this.scoreName] },

    dateEnd () {
      if (this.statusId === this.match.statusId && this.date) {
        return this.$store.getters['Server/live']
      } else if (this.date && this.dateNext) {
        return this.dateNext
      }
      return null
    }
  },
  methods: {
    updateDate (value) {
      const data = { id: this.match.id }
      data[this.dateName] = value
      this.$store.dispatch('Sport/Football/Match/put', data)
    },
    updateDateNext (value) {
      const data = { id: this.match.id }
      data[this.dateNextName] = value
      this.$store.dispatch('Sport/Football/Match/put', data)
    },
    updateStatus () {
      const data = { id: this.match.id, statusId: this.statusId }
      if (!this.date) {
        data[this.dateName] = this.$store.getters['Server/live']
      }

      if (status.scoreUpdate(this.statusId)) {
        for (const index in status.scoreUpdate(this.statusId)) {
          const score = status.scoreUpdate(this.statusId)[index]
          if (this.match[score] === null) {
            const scoreReference = status.scoreUpdateReference(this.statusId) ? status.scoreUpdateReference(this.statusId)[index] : null
            if (scoreReference) {
              data[score] = this.match[scoreReference]
            } else {
              data[score] = 0
            }
          }
        }
      }

      if (this.statusId === 7 && !this.match.possessionHome && !this.match.possessionAway) {
        data.possessionHome = 50
        data.possessionAway = 50
      }

      if (status.periodActive(this.statusId)) {
        const period = status.periodActive(this.statusId)
        if (!this.match[period]) {
          data[period] = true
        }
      }

      this.$store.dispatch('Sport/Football/Match/put', data)
    },
    updateStatusNext () {
      const data = { id: this.match.id, statusId: this.statusNextId }
      if (!this.dateNext) {
        data[this.dateNextName] = this.$store.getters['Server/live']
      }
      this.$store.dispatch('Sport/Football/Match/put', data)
    },
    updateStatusEnd () {
      let statusId = 2
      if (this.match.scoreHome > this.match.scoreAway) {
        statusId = 1
      } else if (this.match.scoreHome < this.match.scoreAway) {
        statusId = 3
      }
      const data = { id: this.match.id, statusId: statusId }
      if (!this.dateNext) {
        data[this.dateNextName] = this.$store.getters['Server/live']
      }
      if (!this.match.dateEnd) {
        Object.assign(data, { dateEnd: this.$store.getters['Server/live'] })
      }
      this.$store.dispatch('Sport/Football/Match/put', data)
    }
  }
}
</script>

<style>
.sportFootballMatchStatusPeriod{
  position: relative;
  display:flex;
  height:60px;
}
.sportFootballMatchStatusPeriod > div {
  position:relative
}
.sportFootballMatchStatusPeriod > div.settings,
.sportFootballMatchStatusPeriod > div.start,
.sportFootballMatchStatusPeriod > div.end,
.sportFootballMatchStatusPeriod > div.endOther{
  flex: 1;
  align-self: center;
  text-align: center;
  width:25px;
  height:25px;
  border:none;
}
.sportFootballMatchStatusPeriod > div.stopwatch,
.sportFootballMatchStatusPeriod > div.offset,
.sportFootballMatchStatusPeriod > div.score{
  flex: 2;
  align-self: center;
  text-align: center;
}
.sportFootballMatchStatusPeriod > div.startDate,
.sportFootballMatchStatusPeriod > div.endDate{
  flex: 3;
  align-self: center;
  text-align: center;
}
</style>
